import { Outlet } from 'react-router-dom';
import { AnnouncementBar } from '../AnnouncementBar';
import { Header } from '../Header';
import { Footer } from '../Footer';
import { ScrollToTop } from '../ScrollToTop';
import styles from './Layout.module.css';

export function Layout() {
  return (
    <div className={styles.layout}>
      <ScrollToTop />
      <AnnouncementBar />
      <Header />
      <main className={styles.main}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
